<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { State } from "../../Model/State"
  import { boardsService, playerService } from "../../Services"
  import { i18n } from "../../Services/i18n"
  import ControlFeedback from "../Shared/ControlFeedback.svelte"
  import FormFeedback from "../Shared/FormFeedback.svelte"
  import InvalidFeedback from "../Shared/InvalidFeedback.svelte"
  import LangIconsSelect from "../Shared/LangIconsSelect.svelte"
  import PictureControl from "../Shared/PictureControl.svelte"

  export let roomId: string
  export let gameCode: string = '';
  export let gameId: string = '';

  const pictureId = new State<string | null>(null)
    const dispatch = createEventDispatcher();

  let formFeedback: FormFeedback
  let playerName = ""
  let isRegistering = false
  let correct = true;

  async function onRegister(): Promise<void> {
    if (isRegistering) {
      return
    }

    formFeedback.validate()

    if (!formFeedback.isValid()) {
      return
    }

    try {
      isRegistering = true
      await playerService.register(playerName, pictureId.value, roomId, gameId);
      await boardsService.createBoard(roomId, gameId, `${gameCode}`.padStart(4, '0'));
      dispatch('boardcreated')
    } catch (error) {
      console.error(error)
    } finally {
      isRegistering = false
    }
  }

  function checkText() {
    const pattern = new RegExp(/^[a-zA-Z]+$/g);
    correct = pattern.test(playerName);
  }
</script>

<div class="player-form">
  <FormFeedback bind:this={formFeedback}>
    <div class="form-control f-center">
      <PictureControl {pictureId} />
    </div>

    <div class="form-control group-name-control">
      <ControlFeedback let:input let:invalid>
        <input
          type="text"
          required
          maxlength="20"
          bind:value={playerName}
          on:input={checkText}
          placeholder={$i18n("Nombre de jugador")}
          class="name-input"
        />
        <InvalidFeedback show={input && invalid}>
          {$i18n("Debe introducir un nombre de usuario")}
        </InvalidFeedback>
        <InvalidFeedback show={!correct && !invalid}>
          {$i18n("No debe contener números")}
        </InvalidFeedback>
      </ControlFeedback>

      <button type="button" on:click={onRegister} disabled={!correct}>
        {$i18n("Entrar")}
      </button>
    </div>


  </FormFeedback>

  <div style="margin-top: 3rem; display: flex; justify-content: center;">
    <LangIconsSelect />
  </div>

</div>

<style lang="scss">
  .player-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px !important;
  }

  .name-input {
    text-align: center;
    width: 100%;
  }

  .group-name-control {
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      margin-top: 1rem;
    }
  }

  :global(input){
    width: 95%;
  }

</style>
